import React, { useState, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonHeader, IonModal } from '@ionic/react'
import { doSwapBuyMobx } from 'restaurant'
import { decorationMobx } from '@mobxStore'
import { Icon } from '@cps'
import ProductItem from './ProductItem'
import productStyleController from '@ctrls/productStyleController'
import './index.scss'

interface IProps {
  reject?: () => void;
  resolve?: (product: any) => void;
}

class WaterfallCalc {
  waterfallData = { styleMap: {}, height: 0, offsetTop: 0 }

  /** 获取瀑布流数据 */
  getWaterfallData () {
    return { ...this.waterfallData }
  }

  /** 原始数据内加上图片宽高 */
  setProductImgHeight (products?: IViewProduct[]) {
    const itemWidth = products.length === 1 ? window.innerWidth - productStyleController.getWidthPer(8) : window.innerWidth / 2 - productStyleController.getWidthPer(5)
    return products.map((item) => {
      if (item.pic) {
        // 计算图片宽高
        let radio = item.picWidth / itemWidth
        let pw = itemWidth
        let ph = item.picHeight / radio
        return {
          ...item,
          pw,
          ph
        }
      }
      return item
    })
  }

  /** 瀑布流计算，支持计算中同时计算图片延迟加载 */
  waterfall (products?: IViewProduct[]) {
    const waterfallWrap = document.querySelector('.exchange-template') as HTMLElement
    if (!waterfallWrap || !waterfallWrap.offsetWidth) {
      return
    }
    let overOff = 0
    let indexPostionMap: any = {}
    const itemWidth = products.length === 1 ? window.innerWidth - productStyleController.getWidthPer(8) : window.innerWidth / 2 - productStyleController.getWidthPer(5)
    document.body.style.setProperty('--exchangewateritemwidth', itemWidth + 'px')
    // 当前容器距离顶部的距离
    const offsetTop = (document.querySelector('.exchange-content') as HTMLElement)?.offsetTop || 0
    let left = productStyleController.getWidthPer(3)
    let top = 0 + overOff
    let lt = 0 + overOff
    let rt = 0 + overOff
    // 容器高度
    let maxH = 100 // 阀值100
    const needReCalc = products.find((product, index) => {
      // 使用后计算方案
      const $productHeight = document.getElementById('exchangeproduct' + product.no)
      // 找不到
      if (!$productHeight) {
        console.log('🚌 瀑布流计算失败，需要重算')
        return true
      }
      const thisHeight: number = $productHeight.offsetHeight
      // TODO 更精准的异常处理
      if (thisHeight === 0) {
        return true
      }
      if (lt <= rt) {
        left = productStyleController.getWidthPer(3)
        top = lt
        lt += thisHeight + 16
      } else {
        left = productStyleController.getWidthPer(5) + itemWidth
        top = rt
        rt += thisHeight + 16
      }
      indexPostionMap[`${product.no}_${index}`] = {
        left,
        top,
        width: itemWidth,
        height: thisHeight,
        imgWidth: itemWidth,
      }
      if (maxH < top + thisHeight) {
        maxH = top + thisHeight
      }
    })
    if (needReCalc) {
      return
    }
    // 处理完 确保计算一次滚动 主要处理未滚动就显示的case
    return (this.waterfallData = { styleMap: indexPostionMap, height: maxH + 10, offsetTop })
  }
}

// 初始化瀑布流
const _waterfallCtrl = new WaterfallCalc()

// 存储计算结果
const _lineToResult = {}

const ExChangeModal: React.FC<IProps> = (props) => {
  const _products = doSwapBuyMobx.doSwapBuy?.products?.filter(item => item.saleCnt !== 0)
  const [products, setProducts] = useState([])
  const [productStyleMap, setProductStyleMap] = useState({} as {
    [no: string]: {
      left: number;
      top: number;
    };
  })
  const [height, setHeight] = useState(420)
  const hashProduct = useMemo(() => {
    return products.map(p => p.no).join('')
  }, [products])
  const calcWaterfall = () => {
    const payload = _waterfallCtrl.waterfall(_products)
    if (payload) {
      const { styleMap, height } = payload
      _lineToResult[hashProduct] = payload
      setProductStyleMap(styleMap)
      setHeight(height)
    } else {
      setTimeout(() => {
        calcWaterfall()
      }, 300)
    }
  }
  useEffect(() => {
    if (products.length && hashProduct) {
      if (_lineToResult[hashProduct]) {
        setProductStyleMap(_lineToResult[hashProduct].styleMap)
        setHeight(_lineToResult[hashProduct].height)
      } else {
        setTimeout(() => {
          calcWaterfall()
        }, 50)
      }
    }
  }, [hashProduct])
  useEffect(() => {
    setProducts(_waterfallCtrl.setProductImgHeight(_products))
    window.addEventListener(window.onorientationchange ? 'orientationchange' : 'resize', () => {
      calcWaterfall()
    }, false)
  }, [])
  useEffect(() => {
    window.addEventListener(window.onorientationchange ? 'orientationchange' : 'resize', () => {
      calcWaterfall()
    }, false)
  }, [])

  const handleClose = () => {
    doSwapBuyMobx.setShowAddCnt(doSwapBuyMobx.showAddCnt + 1)
    props.reject()
  }

  const handleChoose = (product) => {
    doSwapBuyMobx.setShowAddCnt(0)
    props.resolve(product)
  }

  return (
    <IonModal
      cssClass='exchange-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader className='exchange-header'>
        <span>{i18n.t('newCart.exchange')}</span>
        <Icon name='delete' size={26} data-cypid='exchangeModalClose' onClick={handleClose} />
      </IonHeader>
      <IonContent className='exchange-content'>
        <div className='exchange-template' style={{ height }}>
          {
            _products?.map((product, index) => {
              return (<ProductItem key={index} product={product} decorate={decorationMobx.mealDecorates || {} as TMealCommonDecorates} full={_products.length === 1} style={productStyleMap[`${product.no}_${index}`]} onClick={handleChoose} />)
            })
          }
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(ExChangeModal)
